import Swiper from 'swiper';
import { Navigation, Autoplay } from "swiper/modules"

import "swiper/css"
import "swiper/css/autoplay"
// import "swiper/css/effect-fade"

class HeroFront extends HTMLElement {

  constructor() {
    super();
    this.autoplayDelay = 6500;

    this.projectLinksWrapper = this.querySelector('.hero-project-link-wrapper');
    this.projectLinks = this.querySelectorAll('.hero-project-link');
    // set url and label of first link
    const firstProjectTeaser = this.querySelector('.project-teaser-hero');
    this.projectLinks[0].href = firstProjectTeaser.dataset.url;
    this.projectLinks[0].innerText = firstProjectTeaser.dataset.label;
    this.projectLinks[0].style.opacity = 1;
    // adjust width of wrapper
    setTimeout(() => {
      this.projectLinksWrapper.style.width = this.projectLinks[0].getBoundingClientRect().width + 'px';
    }, 0);
    // init link indexes
    this.nextLinkIndex = 0;
    this.prevLinkIndex = 1;
  }

  connectedCallback() {
    const slides = this.querySelectorAll('.swiper-slide');
    if (slides.length > 1) {
      const swiper = new Swiper(this.querySelector('.swiper-hero'), {
        modules: [ Autoplay, Navigation ],
        lazy: true,
        loop: true,
        effect: "slide",
        slidesPerView: 1,
        speed: 720,
        autoplay: {
          delay: this.autoplayDelay,
          pauseOnMouseEnter: false,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        autoHeight: false,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
      });

      swiper.autoplay.pause();
      setTimeout(() => {
        swiper.autoplay.resume();
      }, this.autoplayDelay/2);

      swiper.on('slideChangeTransitionStart', () => {
        const projectTeaser = swiper.slides[swiper.activeIndex].querySelector('.project-teaser-hero');
        // change indexes
        this.nextLinkIndex = 1-this.nextLinkIndex;
        this.prevLinkIndex = 1-this.prevLinkIndex;
        // swap links
        this.projectLinks[this.nextLinkIndex].href = projectTeaser.dataset.url;
        this.projectLinks[this.nextLinkIndex].innerText = projectTeaser.dataset.label;
        this.projectLinksWrapper.style.width = this.projectLinks[this.nextLinkIndex].getBoundingClientRect().width + 'px';
        this.projectLinks[this.nextLinkIndex].style.opacity = 1;
        this.projectLinks[this.nextLinkIndex].style.zIndex = 20;
        this.projectLinks[this.prevLinkIndex].style.opacity = 0;
        this.projectLinks[this.prevLinkIndex].style.zIndex = -10;
      });
    }
  }

}


// Define the new web component
if ('customElements' in window) {
  customElements.define('hero-front', HeroFront);
}
